import React, { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import CustomError from './CustomError';
import { useThemeContext } from "../../contexts/ThemeContext";

type Props = {
  children: JSX.Element | JSX.Element[];
};

const ErrorBoundaryComponent: FC<Props> = ({ children }) => {
  const { clientThemeSettings } = useThemeContext();

  return (
    <ErrorBoundary fallbackRender={({ resetErrorBoundary }) => <CustomError resetErrorBoundary={resetErrorBoundary} clientThemeSettings={clientThemeSettings} />}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryComponent;
